import { History } from "lucide-react";
import { DownloadPayroll } from "@/components/payroll/PayrollFinalized";
import { inr, fmtDateTime } from "@/lib/format";

export default function PayrollHistory({ runs, onOpen, current }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200" data-testid="payroll-history">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center gap-2 font-heading font-semibold text-slate-800"><History className="h-4 w-4 text-blue-800" /> Payroll History</div>
      {runs.length === 0 ? (
        <div className="px-5 py-8 text-sm text-slate-500 text-center" data-testid="payroll-history-empty">No payroll has been finalized yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
              <tr>{["Payroll Month", "Employees", "Total Earned", "Total Deductions", "Total Final Payable", "Finalized", ""].map((h, i) => <th key={h || i} className={`px-4 py-2.5 ${i >= 1 && i <= 4 ? "text-right" : "text-left"}`}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {runs.map((r) => (
                <tr key={r.month} className={`border-t border-slate-100 ${r.month === current ? "bg-blue-50/60" : "hover:bg-slate-50"}`} data-testid={`history-row-${r.month}`}>
                  <td className="px-4 py-2.5">
                    <button className="font-semibold text-blue-800 hover:underline" onClick={() => onOpen(r.month)} data-testid={`history-open-${r.month}`}>{r.month_label}</button>
                    {r.status === "reopened" && <span className="ml-2 text-[11px] rounded border border-amber-300 bg-amber-50 text-amber-800 px-1.5 py-0.5" data-testid={`history-reopened-${r.month}`}>Reopened</span>}
                  </td>
                  <td className="px-4 py-2.5 text-right money">{r.employees}</td>
                  <td className="px-4 py-2.5 text-right money">{inr(r.totals.earned)}</td>
                  <td className="px-4 py-2.5 text-right money text-red-700">{inr(r.totals.deduction)}</td>
                  <td className="px-4 py-2.5 text-right money font-semibold text-blue-800">{inr(r.totals.final)}</td>
                  <td className="px-4 py-2.5 text-xs text-slate-500 whitespace-nowrap">{fmtDateTime(r.finalized_at)}</td>
                  <td className="px-4 py-2.5 text-right">{r.status === "finalized" ? <DownloadPayroll month={r.month} size="sm" testid={`history-download-${r.month}`} /> : <span className="text-xs text-slate-400">Being revised</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
